import { z } from "zod";

export const SLUG_RE = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

/**
 * C1 : miroir front du minimum contractuel de TENANT_RESERVED_SUBDOMAINS
 * (backend, env). Le back reste l'autorité (unicité en base vérifiée au submit) ;
 * ici on rejette instantanément les sous-domaines réservés côté client.
 */
export const RESERVED_SUBDOMAINS = new Set([
  "ada",
  "app",
  "dalan",
  "www",
  "api",
  "admin",
  "static",
  "assets",
  "mail",
  "portal",
]);

/**
 * Aucun mot de passe à l'inscription (ADR 0033, 3e addendum) : il est défini
 * depuis le lien reçu par e-mail, qui prouve l'adresse du même geste.
 */
export const signupSchema = z.object({
  name: z
    .string()
    .min(2, "Le nom de la clinique est requis.")
    .max(255, "255 caractères maximum."),
  slug: z
    .string()
    .min(2, "2 caractères minimum.")
    .max(63, "63 caractères maximum.")
    .regex(SLUG_RE, "Minuscules, chiffres et tirets.")
    .refine((v) => !RESERVED_SUBDOMAINS.has(v), "Ce sous-domaine est réservé."),
  admin_email: z.string().email("Adresse e-mail invalide."),
  // C12 : consentement explicite, case non pré-cochée (doit être true).
  privacy_accepted: z.boolean().refine((v) => v === true, {
    message: "Vous devez accepter la politique de confidentialité.",
  }),
});

export type SignupForm = z.infer<typeof signupSchema>;
